import { atom, selectorFamily } from "recoil";
import { FamilyService } from "./services/family";

export const familyGroupState = atom({
    key: "familyGroup",
    default: [],
});

export const tutoresGroupState = atom({
    key: "tutoresGroup",
    default: [],
});

export const showModalFamilyGroupState = atom({
    key: "showModalFamilyGroup",
    default: false,
});

export const showModalConfirmFamilyGroupState = atom({
    key: "showModalConfirmFamilyGroup",
    default: false,
});

export const tutRutConfirmState = atom({
    key: "tutRutConfirm",
    default: "",
});

export const readFamilyTextFetchState = selectorFamily({
    key: "readFamilyTextFetch",
    get:
        () =>
            async ({ get }) => {
                return await FamilyService.getBodyHtml()
            },
});
